import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Dropdown, Space } from "antd";
import axios from "../services/axios";
import ChangePassword from "../pages/Authentication/ChangePassword";
import {
  DownOutlined,
  SearchOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import useSearchContext from "../hooks/useSearchContext";
import useDocSearchContext from "../hooks/useDocSearchContext";
import NotificationBell from "./Notifications";
import { usePermissions } from "../context/PermissionContext";
const pathCheck = [
  "candidates",
  "candidate",
  "documents",
  "trf",
  "bulkUpload",
  "build",
  "forms",
  "question",
  "trf_process",
  "tin",
  "digital",
  "add",
  "client",
  "consultant",
  "call",
  "logs",
  "feedback",
  "inactive",
  "active_inactive",
  "login",
  "assigntrf",
  "queries",
  "users",
  "api_logs",
  "service",
  "settings",
  "generate-excel",
];

const hidePathCheck = ["/logs/interview"];

const buttonStyle = {
  margin: "2px",
  borderRadius: "5px",
  color: "black",
};

function Navbar({ title, isMenuExpanded, setIsMenuExpanded }) {
  const history = useHistory();
  const path = history.location.pathname.split("/");
  const [notificationData, setNotificationData] = useState([]);
  const [open, setOpen] = useState(false);
  const { resetPermissions } = usePermissions();
  const {
    setSearch,
    setLocation,
    setFormId,
    setTrfId,
    setInterviewStatus,
    setDefaultDate,
    setHeaderFilterStatus,
    setSelectedDatevalue,
    setSource,
    setQualification,
    setCallMasterId,
    setRecruiter,
    setPositions,
    setAdvanceappliedFilters,
    setNormalFilters,
    setFilterFetched,
    setSubTabCount,
    setDynamicRounds,
    setDelaySubTabCount,
  } = useSearchContext();

  const {
    setFormId: docSetFormId,
    setBusinessType,
    setSearch: docSetSearch,
    setLocation: docSetLocation,
    setOnboardStatus,
  } = useDocSearchContext();

  // useEffect(() => {
  //   axios
  //     .get(
  //       "/interviews/RescheduleInterview/" + localStorage.getItem("user.id"),
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("user.token")}`,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       //console.log("NOTIFICATION", res.data);
  //       setNotificationData(res?.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  function onClickLogout() {
    setLocation([]);
    setHeaderFilterStatus("Application_Received");
    localStorage.removeItem("headerFilterStatus");
    setFormId("");
    setSearch("");
    setQualification([]);
    setInterviewStatus("");
    setTrfId("");
    setSource([]);
    setRecruiter([]);
    setCallMasterId("");
    setDefaultDate([]);
    setPositions([]);
    setAdvanceappliedFilters(0);
    setNormalFilters(0);
    setSelectedDatevalue("Last 30 Days");
    setFilterFetched(false);
    docSetSearch("");
    setBusinessType("");
    setOnboardStatus("");
    docSetFormId("");
    docSetLocation("");
    setDynamicRounds([]);
    setSubTabCount({});
    setDelaySubTabCount({});

    localStorage.clear();
   
    resetPermissions();
    history.push("/logout");
  }

  const dateConverter = (d, i) => {
    const date = d.split("T");
    let p = date[0].split(/\D/g);
    let t = date[1].split(".");
    if (i) {
      return [p[0], p[1], p[2]].join("-");
    } else {
      return [p[2], p[1], p[0]].join("-") + " " + t[0];
    }
  };

  // console.log("notification data", notificationData);

  const items = [
    {
      key: "1",
      label: (
        <button className="dropdown-item" onClick={(e) => setOpen(true)}>
          <i className="fa fa-user fa-fw mr-2"></i>
          Change Password
        </button>
      ),
    },
    {
      key: "2",
      label: (
        <button className="dropdown-item" onClick={onClickLogout}>
          <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2"></i>
          Logout
        </button>
      ),
    },
  ];

  return (
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 mt-0 static-top shadow">
      <div>
        <button
          style={{ outline: "none" }}
          onClick={() => setIsMenuExpanded(!isMenuExpanded)}
        >
          {!isMenuExpanded ? (
            <MenuFoldOutlined style={{ fontSize: "1.5rem" }} />
          ) : (
            <MenuUnfoldOutlined style={{ fontSize: "1.5rem" }} />
          )}
        </button>
        {/* <span className="navbar-brand">{title}</span> */}
      </div>

      {/* <span class="d-flex custom-border-bottom border-2 align-items-center ms-4">
        <SearchOutlined className="custom-grey-text" />
        <input
          type="text"
          class="px-2 border-0 outline-none"
          placeholder="Search"
        />
      </span> */}

      {/* <div>
        {pathCheck.includes(path[1]) && (
          <>
            <Button style={buttonStyle} onClick={() => history.goBack()}>
              <i class="fas fa-arrow-left mr-1" aria-hidden="true"></i> Back
            </Button>
            <Button style={buttonStyle} onClick={() => history.goForward()}>
              Next<i class="fas fa-arrow-right ml-1" aria-hidden="true"></i>
            </Button>
          </>
        )}
      </div> */}

      <div className="d-flex justify-content-end ml-auto gap-2">
        <div className="flex gap-1 items-center">
          <NotificationBell />
          <Dropdown
            className="mr-4"
            menu={{ items }}
            trigger={["click", "hover"]}
            arrow
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space className="flex items-center">
                <i style={{ fontSize: 22 }} className="fa fa-user fa-fw"></i>
                {localStorage.getItem("user.name")}
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>
        </div>
        {open && <ChangePassword closeModal={setOpen} openModal={open} />}
      </div>
    </nav>
  );
}

export default Navbar;
